import React from 'react';
import MarkdownPage from '../Components/InfoPages/MarkdownPage';

function CXBTPage() {
  return <MarkdownPage slug="cxbt" titleKey="infoPages.cxbtTitle" />;
}

export default CXBTPage;
